import Pane from './Pane.js'

/**
 * Table pane
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {String} props.title
 * @param {Boolean} props.hasFilters
 * @param {React.ReactNode} props.children
 * @param {Boolean} props.canExport
 * @param {Function} props.onExport
 * @returns {React.ReactNode}
 */
export default function TablePane({
  isLoading,
  title,
  hasFilters,
  children,
  canExport,
  onExport,
}) {
  return (
    <Pane
      title={title}
      isLoading={isLoading}
      canExport={canExport}
      onExport={onExport}
    >
      {!isLoading && (
        <table className="table--analytics">
          {children || (
            <tbody>
              <tr>
                <td>
                  <dl className="list list--horiz-bar-graph centered-text hide-for-loading">
                    <dt className="list__item margin-bottom-0 make-medium-dark-grey">
                      <strong>No data to display for this table</strong>
                    </dt>
                    {hasFilters && (
                      <dd className="list__item list__item--sm make-medium-grey">
                        Adjust the filters or date range and try again
                      </dd>
                    )}
                  </dl>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      )}
    </Pane>
  )
}
